import React from 'react'

import './styles.scss'
const swatchSize = 12
export const Key = ({
  entries
}: {
  entries: {
    type: 'line' | 'shape' | 'none' | 'shape-pattern'
    label: string
    color: string
  }[]
}) => {
  return (
    <div className='Key'>
      {entries.map((m, i) => {
        return (
          <div className='entry' key={'Key_' + i}>
            <div className='swatch'>
              {m.type === 'shape' ? (
                <SwatchShape color={m.color} />
              ) : m.type === 'shape-pattern' ? (
                <SwatchShapePattern color={m.color} />
              ) : m.type === 'line' ? (
                <SwatchLine color={m.color} />
              ) : (
                <SwatchNone />
              )}
            </div>
            <div className='label'>{m.label}</div>
          </div>
        )
      })}
    </div>
  )
}

const SwatchShape = ({ color }: { color: string }) => {
  return (
    <svg width={swatchSize} height={swatchSize}>
      <rect width={swatchSize} height={swatchSize} fill={color} />
    </svg>
  )
}
const SwatchShapePattern = ({ color }: { color: string }) => {
  return (
    <svg width={swatchSize} height={swatchSize}>
      <pattern
        id='diagonalHatch'
        patternUnits='userSpaceOnUse'
        width='4'
        height='4'
        style={{transform:"scale(1.5)"}}
      >
        <path
          d='M-1,1 l2,-2 M0,4 l4,-4 M3,5 l2,-2'
          style={{ stroke: color, strokeWidth: 1 }}
        />
      </pattern>
      <rect width={swatchSize} height={swatchSize} fill='url(#diagonalHatch)' />
    </svg>
  )
}
const SwatchLine = ({ color }: { color: string }) => {
  return (
    <svg width={swatchSize} height={swatchSize}>
      <line
        x2={swatchSize}
        y1={swatchSize}
        y2={0}
        stroke={color}
        strokeWidth={4}
      />
    </svg>
  )
}
const SwatchNone = () => {
  return <svg width={swatchSize} height={swatchSize}></svg>
}
